var _style, _defs, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _g2, _path14, _path15, _g3, _path16, _path17, _path18, _defs2, _g4, _path19, _path20, _g5, _rect, _polygon, _defs3, _g6, _polygon2, _polyline, _polyline2, _polygon3, _path21, _path22, _defs4, _g7, _path23, _path24, _g8, _rect2, _polygon4, _defs5, _g9, _polygon5, _polyline3, _polyline4, _polygon6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeaver1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 993.7 662.2",
    style: {
      enableBackground: "new 0 0 993.7 662.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_4_);}\r\n\t.st1{fill:#4F968B;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st2{fill:#2F6D66;stroke:#010101;stroke-width:5;stroke-miterlimit:10.0001;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#FABA29;}\r\n\t.st5{fill:#412514;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st6{fill:#8C796E;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st7{fill:#FFFFFF;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st8{fill:#010101;}\r\n\t.st9{fill:none;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st10{fill:#C12026;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st11{clip-path:url(#SVGID_6_);}\r\n\t.st12{fill:#751113;}\r\n\t.st13{fill:#521413;}\r\n\t.st14{fill:#311312;}\r\n\t.st15{clip-path:url(#SVGID_7_);}\r\n\t.st16{clip-path:url(#SVGID_9_);}\r\n\t.st17{clip-path:url(#SVGID_10_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_2_",
    y: 0,
    width: 993.7,
    height: 662.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 478.3,
    cy: 139.3,
    rx: 152.6,
    ry: 130.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9943 -0.1067 0.1067 0.9943 -22.6296 55.2481)",
    className: "st2",
    cx: 505,
    cy: 239.1,
    rx: 257.5,
    ry: 168.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M559.9,324.9c3.7,2.7,7.7,4.6,12,6.1c2.3,0.4,4.7,0.6,7.1,0.6c22.6,0,41-18.4,41-41c0-22.7-18.4-41-41-41 c-22.7,0-41,18.4-41,41c0,10,3.6,19.1,9.5,26.2C551.5,319,555.6,321.7,559.9,324.9z M563.4,277.4c-0.1,0.6-0.2,1.3-0.2,2 c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1c0-4.2-2.9-7.8-6.8-8.8c1.5-0.3,3-0.5,4.6-0.5c11.3,0,20.5,9.2,20.5,20.5 s-9.2,20.5-20.5,20.5s-20.5-9.2-20.5-20.5C558.5,285.6,560.3,281,563.4,277.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M414.7,331.6c2.4,0,4.8-0.2,7.1-0.6c4.3-1.5,8.3-3.5,12-6.1c4.3-3.1,8.4-5.8,12.4-8 c5.9-7.1,9.5-16.2,9.5-26.2c0-22.7-18.4-41-41-41s-41,18.4-41,41S392.1,331.6,414.7,331.6z M399,277.4c-0.1,0.6-0.2,1.3-0.2,2 c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1c0-4.2-2.9-7.8-6.8-8.8c1.5-0.3,3-0.5,4.6-0.5c11.3,0,20.5,9.2,20.5,20.5 s-9.2,20.5-20.5,20.5s-20.5-9.2-20.5-20.5C394.2,285.6,396,281,399,277.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M723,595.8c-1.1,2.8-2.5,6-4.2,9.5c-2.1,4.1-4.4,8.7-7.6,13.1c-3.1,4.4-6.8,9-11.4,12.5 c-2.2,1.8-4.7,3.3-7.3,4.6c-2.7,1.1-5.4,2-8.4,2.3c-5.9,0.8-12.5-0.3-19-2.6l-0.6-0.2l-0.3-0.1l-0.2-0.1h-0.1l-1-0.5l-2.7-1.2 c-1-0.4-1.4-0.8-2-1.2s-1.2-0.8-1.8-1.1c-2.4-2-4.8-4.2-6.4-7c-3.5-5.5-5.5-12.4-6.3-19.6c-0.8-7.2-0.4-14.6,0.3-21.7 c0.7-7.2,2-14.1,3.5-20.7c1.4-6.6,3.1-12.7,4.7-18.4c3.3-11.4,6.6-20.7,9-27.2s3.9-10.2,3.9-10.2s-2.2,3.4-5.6,9.4 c-3.4,6.1-8,15-12.8,26.1c-4.6,11.1-9.6,24.4-12.6,39.5c-1.5,7.6-2.4,15.6-2.1,24c0.1,2.1,0.3,4.2,0.5,6.4 c0.4,2.1,0.7,4.3,1.2,6.5l0.9,3.2l0.5,1.6l0.7,1.6l1.3,3.2c0.5,1,1.1,2,1.7,3.1c1.1,2.1,2.6,3.9,4,5.8c0.7,1,1.6,1.8,2.4,2.6 l2.6,2.5l3.1,2.2c1,0.7,2.2,1.6,3,1.9l2.6,1.4l1.3,0.7l0.5,0.2h0.1l0.2,0.1l0.4,0.2l0.8,0.3c8,3.2,17,5.1,26,4 c4.5-0.5,8.7-1.9,12.6-3.6c0.1,0,0.2-0.1,0.3-0.1c-21.1,36.9-48.7,67.8-80.9,90.1c-6.9,4.8-14.9,7.1-22.7,7.1 c-12.2,0-24.3-5.6-32-16.3c-14.9-20.6-39.1-34-66.5-34c-27.3,0-51.6,13.4-66.5,34c-7.7,10.6-19.8,16.4-32.1,16.4 c-7.7,0-15.4-2.2-22.2-6.9c-31.2-21.5-58.1-51-78.9-86.3c-0.8-1.4-1.6-2.7-2.4-4.1c0.1,0,0.2,0.1,0.3,0.1c3.9,1.7,8.2,3,12.6,3.6 c8.9,1.1,18-0.8,26-4l0.8-0.3l0.4-0.2l0.2-0.1h0.1l0.5-0.2l1.3-0.7l2.6-1.4c0.8-0.3,2-1.2,3-1.9l3.1-2.2l2.6-2.5 c0.8-0.8,1.7-1.6,2.4-2.6c1.5-1.9,3-3.7,4-5.8c0.6-1,1.2-2,1.7-3.1l1.3-3.2l0.6-1.6l0.5-1.6l0.9-3.2c0.5-2.2,0.8-4.3,1.2-6.5 c0.2-2.1,0.4-4.3,0.5-6.4c0.2-8.4-0.6-16.5-2.1-24c-0.4-2.1-0.9-4.1-1.3-6.1c-3-12.6-7.3-23.8-11.3-33.4 c-4.8-11.1-9.4-20-12.8-26.1c-3.4-6.1-4.1-5.8-1.7,0.8c2.4,6.5,5.7,15.9,9,27.2c1.5,5.3,3.1,11,4.4,17c0.1,0.5,0.2,0.9,0.3,1.4 c1.5,6.6,2.8,13.5,3.5,20.7s1.1,14.5,0.3,21.7c-0.7,7.2-2.7,14.1-6.3,19.6c-1.7,2.8-4,5-6.4,7c-0.6,0.4-1.2,0.7-1.8,1.1 c-0.7,0.4-1,0.8-2,1.2l-2.7,1.2l-1,0.5h-0.1l-0.2,0.1l-0.3,0.1l-0.6,0.2c-6.5,2.4-13.1,3.4-19,2.6c-3-0.3-13.5-5.1-15.7-6.9 c-4.6-3.5-8.3-8.1-11.4-12.5c-3.1-4.5-5.5-9-7.6-13.1c-1.7-3.5-3.1-6.7-4.2-9.6c-12.8-36.4-19.9-76.5-19.9-118.7 c0-21.6,1.9-42.6,5.4-62.9c10.9-62.3,37.5-117.6,74.6-159c-6.1-1.7-11.8-5-16.6-9.8c-15-15-15-39.6,0-54.7 c7.5-7.5,17.4-11.3,27.3-11.3s19.8,3.8,27.3,11.3c6.1,6.1,9.7,13.8,10.9,21.8c0,0,0.6-0.6,1.7-1.7c3.4-4.1,7-8.3,11-12.6 c3.9-4.2,8.1-8.5,12.5-12.8c34.2-32.8,85-65.2,156.6-73.8c0,0-16.2,11.5-31.5,27.8c30.9-4.6,65.8-4.1,104,5.1 c0,0-41.8,11-66.3,32.4c-1.7,1.4-3.3,2.9-4.7,4.5c-1.4,1.5-2.8,3-4,4.6c19.4,6.2,37.8,15.1,55,26.5c1.1-8,4.8-15.7,10.9-21.8 c7.5-7.5,17.4-11.3,27.3-11.3c9.9,0,19.8,3.8,27.3,11.3c15,15,15,39.6,0,54.7c-4.8,4.8-10.5,8-16.6,9.8c49.2,55,80,134.1,80,221.9 C742.9,519.2,735.8,559.4,723,595.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.5,199.6c-10,0-18.2,8.1-18.2,18.2c0,10,8.1,18.2,18.2,18.2c10,0,18.2-8.1,18.2-18.2 C359.6,207.7,351.5,199.6,341.5,199.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M652.3,199.6c-10,0-18.2,8.1-18.2,18.2c0,10,8.1,18.2,18.2,18.2c10,0,18.2-8.1,18.2-18.2 C670.4,207.7,662.3,199.6,652.3,199.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M662.9,255.1c6.1-1.7,11.8-5,16.6-9.8c15-15,15-39.6,0-54.7c-7.5-7.5-17.4-11.3-27.3-11.3 c-9.9,0-19.8,3.8-27.3,11.3c-6.1,6.1-9.7,13.8-10.9,21.8c-17.2-11.4-35.7-20.4-55-26.5c1.2-1.6,2.6-3.1,4-4.6 c1.5-1.5,3.1-3,4.7-4.5c24.6-21.4,66.3-32.4,66.3-32.4c-38.2-9.2-73.1-9.7-104-5.1c15.3-16.3,31.5-27.8,31.5-27.8 c-71.5,8.6-122.4,41.1-156.6,73.8c-4.5,4.3-8.6,8.6-12.5,12.8c-3.9,4.3-7.6,8.5-11,12.6c-1.1,1.1-1.7,1.7-1.7,1.7 c-1.1-8-4.8-15.7-10.9-21.8c-7.5-7.5-17.4-11.3-27.3-11.3s-19.8,3.8-27.3,11.3c-15,15-15,39.6,0,54.7c4.8,4.8,10.5,8,16.6,9.8 c-37.1,41.5-63.7,96.7-74.6,159c-3.5,20.3-5.4,41.3-5.4,62.9c0,42.2,7.1,82.3,19.9,118.7c1.1,2.8,2.5,6,4.2,9.6 c2.1,4.1,21.5,46.2,22.3,47.6c20.8,35.3,47.8,64.8,78.9,86.3c6.8,4.7,14.5,6.9,22.2,6.9c12.3,0,24.4-5.7,32.1-16.4 c14.9-20.6,39.1-34,66.5-34c27.3,0,51.6,13.4,66.5,34c7.7,10.6,19.7,16.3,32,16.3c7.9,0,15.8-2.3,22.7-7.1 c31.5-21.8,58.6-51.9,79.5-87.7l0,0v-0.1c0.4-0.8,24.3-52.4,25.4-55.2c12.8-36.4,19.9-76.6,19.9-118.8 C742.9,389.2,712.1,310.1,662.9,255.1z M652.3,199.6c10,0,18.2,8.1,18.2,18.2c0,10-8.1,18.2-18.2,18.2c-10,0-18.2-8.1-18.2-18.2 C634.1,207.7,642.2,199.6,652.3,199.6z M341.5,235.9c-10,0-18.2-8.1-18.2-18.2c0-10,8.1-18.2,18.2-18.2c10,0,18.2,8.1,18.2,18.2 C359.6,227.8,351.5,235.9,341.5,235.9z M560,436.7L560,436.7c-1.2,0-2.3,0-3.5-0.1c-19.2-0.8-49.4-20.4-51.6-21.9 c-2.5-1.7-5.6-3.4-8.1-3.4s-5.6,1.8-8.1,3.4c-2.2,1.5-32.4,21.1-51.6,21.9c-1.1,0.1-2.3,0.1-3.5,0.1l0,0 c-38.4-0.1-69.6-27.6-69.6-61.6c0-33.5,46.5-14.8,77.6-35.9c0.5-0.3,1-0.6,1.5-0.9c2.8-2,5.4-3.8,7.9-5.3c0.5-0.4,1-0.7,1.6-1.1 c2.6-1.7,5.6-3.3,9.4-4.6c7.5-2.7,16.8-4.5,26.9-5.1c2.6-0.2,5.2-0.3,7.9-0.3c2.7,0,5.3,0.1,7.9,0.3c10.1,0.6,19.5,2.3,26.9,5.1 c3.8,1.4,6.8,3,9.4,4.6c0.5,0.4,1.1,0.7,1.6,1.1c2.5,1.5,5.2,3.3,7.9,5.3c0.5,0.4,1,0.6,1.5,0.9c31.1,21.2,77.6,2.5,77.6,36 C629.6,409.1,598.5,436.6,560,436.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M484.7,497.6c-10.5-0.6-19.2-1.4-21.5-2.1c0,0,15,28,33.3,29.9c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0 c18.3-1.8,33.3-29.9,33.3-29.9c-2.3,0.7-10.9,1.5-21.5,2.1C500.9,498.1,492.8,498.1,484.7,497.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M579,249.6c22.6,0,41,18.4,41,41c0,22.7-18.4,41-41,41c-2.4,0-4.8-0.2-7.1-0.6c-4.3-1.5-8.3-3.5-12-6.1 c-4.3-3.1-8.4-5.8-12.4-8c-5.9-7.1-9.5-16.2-9.5-26.2C538,268,556.4,249.6,579,249.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M579,311.1c11.3,0,20.5-9.2,20.5-20.5s-9.2-20.5-20.5-20.5c-1.6,0-3.1,0.2-4.6,0.5c3.9,1,6.8,4.5,6.8,8.8 c0,5-4.1,9.1-9.1,9.1s-9.1-4.1-9.1-9.1c0-0.7,0.1-1.4,0.2-2c-3,3.6-4.8,8.2-4.8,13.2C558.5,301.9,567.7,311.1,579,311.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M433.8,455.4c0-17.2,33.8-46.4,68.7-46.4s57.5,29.2,57.5,46.4S532.2,489,497.4,489S433.8,472.5,433.8,455.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M505,457.9v-37.5c3.6,2.9,7.4,5.5,11.5,7.8c12.7,7.2,27.1,11.2,42.1,11.6c-1.4,8.4-3.4,16.5-6.2,24.1 c-2.1,5.9-7.2,9.7-12.8,9.7h-20.8C511.2,473.7,505,466.6,505,457.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M559.8,439.3c-1,0-1.9,0-2.9-0.1h-0.5c-20.8-0.8-52.6-22.1-52.9-22.4c-2.8-1.9-5.2-3-6.7-3s-3.9,1.1-6.7,3 c-0.3,0.2-32.1,21.5-52.9,22.4h-0.5c-1,0-1.9,0.1-2.9,0.1h-0.2c-39.8-0.1-72.1-28.9-72.1-64.1c0-21.7,18-23.8,37.1-26 c13.6-1.6,29-3.4,41.6-12c0.3-0.2,0.5-0.3,0.8-0.5c0.2-0.1,0.4-0.2,0.6-0.4c2.6-1.9,5.3-3.7,8-5.4c0.5-0.3,1-0.7,1.4-1l0.2-0.1 c2.9-1.9,6.2-3.5,9.9-4.9c7.6-2.8,17.2-4.6,27.6-5.2c2.9-0.2,5.5-0.3,8-0.3s5.1,0.1,8,0.3c10.5,0.6,20,2.4,27.6,5.2 c3.7,1.4,7,3,9.9,4.9l0.2,0.1c0.5,0.3,1,0.6,1.4,1c2.7,1.6,5.4,3.4,8,5.4c0.2,0.1,0.4,0.3,0.6,0.4c0.3,0.2,0.5,0.3,0.8,0.5 c12.5,8.5,28,10.4,41.6,12c19.1,2.3,37.1,4.4,37.1,26C631.9,410.4,599.6,439.2,559.8,439.3L559.8,439.3z M496.9,335.3 c-1.5,0-3,0-4.6,0.1c-22.4,0.9-38,7.5-38,16.1c0,7.9,2.2,15.7,6.4,22.4c7.8,12.7,21.4,20.2,36.2,20.2c14.9,0,28.4-7.5,36.2-20.2 c4.2-6.7,6.4-14.5,6.4-22.4c0-8.6-15.6-15.2-38-16.1C499.8,335.3,498.3,335.3,496.9,335.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M496.9,321.9c2.7,0,5.3,0.1,7.9,0.3c10.1,0.6,19.5,2.3,26.9,5.1c3.8,1.4,6.8,3,9.4,4.6 c0.5,0.4,1.1,0.7,1.6,1.1c2.5,1.5,5.2,3.3,7.9,5.3c0.5,0.4,1,0.6,1.5,0.9c31.1,21.2,77.6,2.5,77.6,36c0,33.9-31.1,61.5-69.6,61.6 c-0.1,0-0.2,0-0.2,0c-1.1,0-2.2-0.1-3.2-0.1c-19.2-0.8-49.4-20.4-51.6-21.9c-2.5-1.7-5.6-3.4-8.1-3.4s-5.6,1.8-8.1,3.4 c-2.2,1.5-32.4,21.1-51.6,21.9c-1.1,0-2.1,0.1-3.2,0.1c-0.1,0-0.2,0-0.2,0c-38.4-0.1-69.6-27.6-69.6-61.6 c0-33.5,46.5-14.8,77.6-35.9c0.5-0.3,1-0.6,1.5-0.9c2.8-2,5.4-3.8,7.9-5.3c0.5-0.4,1-0.7,1.6-1.1c2.6-1.7,5.6-3.3,9.4-4.6 c7.5-2.7,16.8-4.5,26.9-5.1C491.6,322,494.2,321.9,496.9,321.9 M496.9,396.6c16.2,0,30.4-8.5,38.4-21.4c4.3-6.9,6.8-15,6.8-23.7 c0-11.6-19.5-17.8-40.4-18.6c-1.6-0.1-3.2-0.1-4.7-0.1c-1.6,0-3.2,0-4.7,0.1c-20.9,0.8-40.4,7-40.4,18.6c0,8.7,2.5,16.8,6.7,23.7 C466.4,388,480.6,396.6,496.9,396.6 M496.9,316.9c-2.5,0-5.2,0.1-8.2,0.3c-10.7,0.6-20.5,2.5-28.3,5.4c-3.8,1.4-7.3,3.1-10.4,5.1 l-0.2,0.1c-0.5,0.3-1,0.6-1.5,1c-2.7,1.7-5.5,3.5-8.1,5.5c-0.1,0-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.4-0.9,0.6 c-12,8.2-27.1,10-40.5,11.6c-9.9,1.2-19.2,2.3-26.3,5.8c-8.7,4.4-13,11.8-13,22.7c0,17.9,7.8,34.6,22.1,47.2 c14,12.4,32.7,19.3,52.5,19.4c0.1,0,0.2,0,0.3,0c1,0,2,0,3-0.1h0.5c21.5-0.9,53.9-22.6,54.2-22.8c3-2,4.8-2.6,5.3-2.6 s2.3,0.5,5.3,2.6c0.3,0.2,32.8,21.9,54.2,22.8h0.5c1,0,1.9,0.1,3,0.1c0.1,0,0.2,0,0.3,0l0,0c19.8-0.1,38.5-6.9,52.5-19.4 c14.2-12.6,22.1-29.4,22.1-47.2c0-10.9-4.2-18.3-13-22.7c-7.1-3.6-16.4-4.7-26.3-5.8c-13.3-1.6-28.4-3.4-40.5-11.6 c-0.3-0.2-0.6-0.4-0.9-0.6c-0.2-0.1-0.3-0.2-0.4-0.3c-2.7-2-5.4-3.8-8.1-5.5c-0.5-0.4-1-0.7-1.5-1l-0.2-0.1 c-3.1-2-6.6-3.7-10.4-5.1c-7.8-2.9-17.6-4.8-28.3-5.4C502.1,317,499.4,316.9,496.9,316.9L496.9,316.9z M496.9,391.6 c-14,0-26.7-7.1-34.1-19c-3.9-6.3-6-13.6-6-21.1c0-7,15.3-12.8,35.6-13.6c1.6-0.1,3.1-0.1,4.5-0.1s2.9,0,4.5,0.1 c20.3,0.8,35.6,6.6,35.6,13.6c0,7.5-2.1,14.8-6,21.1C523.6,384.5,510.8,391.6,496.9,391.6L496.9,391.6z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M414.7,249.6c22.7,0,41,18.4,41,41c0,10-3.6,19.1-9.5,26.2c-4,2.2-8.2,4.9-12.4,8c-3.6,2.7-7.7,4.6-12,6.1 c-2.3,0.4-4.7,0.6-7.1,0.6c-22.6,0-41-18.4-41-41C373.7,268,392.1,249.6,414.7,249.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M414.7,311.1c11.3,0,20.5-9.2,20.5-20.5s-9.2-20.5-20.5-20.5c-1.6,0-3.1,0.2-4.6,0.5c3.9,1,6.8,4.5,6.8,8.8 c0,5-4.1,9.1-9.1,9.1s-9.1-4.1-9.1-9.1c0-0.7,0.1-1.4,0.2-2c-3,3.6-4.8,8.2-4.8,13.2C394.2,301.9,403.4,311.1,414.7,311.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M434.5,654.6c-7,0-12-1.9-15.5-5.9c-3.7-4.3-5.5-11.1-5.5-20.7c0-21.7,8.9-44.2,24.3-61.7 c16.3-18.5,37.2-28.7,59-28.7s42.7,10.2,59,28.7c15.4,17.5,24.3,40,24.3,61.7c0,18.4-6.5,26.6-21,26.6c-6.7,0-14.6-1.7-23.7-3.6 c-11.6-2.4-24.7-5.2-38.6-5.2s-27,2.7-38.6,5.2C449.1,653,441.2,654.6,434.5,654.6L434.5,654.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M496.9,540.1c44.6,0,80.8,44.9,80.8,87.9c0,18.8-6.9,24.1-18.5,24.1c-14.8,0-37.2-8.7-62.3-8.7 c-25.1,0-47.5,8.7-62.3,8.7c-11.5,0-18.5-5.3-18.5-24.1C416.1,585,452.2,540.1,496.9,540.1 M496.9,535.1 c-22.5,0-44.1,10.5-60.9,29.5c-15.8,18-24.9,41.1-24.9,63.3c0,10.3,2,17.6,6.1,22.4c3.9,4.5,9.6,6.7,17.3,6.7 c7,0,15-1.7,24.2-3.6c11.4-2.4,24.4-5.1,38.1-5.1s26.6,2.7,38.1,5.1c9.3,1.9,17.3,3.6,24.2,3.6c7.8,0,13.4-2.2,17.3-6.7 c4.1-4.8,6.1-12.1,6.1-22.4c0-22.3-9.1-45.4-24.9-63.3C541,545.6,519.3,535.1,496.9,535.1L496.9,535.1z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M435.2,439.9c15-0.5,29.5-4.5,42.1-11.6c4.1-2.3,7.9-4.9,11.5-7.8V458c0,8.7-6.2,15.8-13.9,15.8h-20.8 c-5.6,0-10.7-3.8-12.8-9.7C438.6,456.4,436.5,448.3,435.2,439.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418,569.9v257c1.7-1.5,3.3-3.1,4.7-4.9c16.6-20.6,43.6-34,74.2-34s57.6,13.4,74.2,34c1.4,1.8,3,3.4,4.7,4.9 V570.2C577.5,588.8,465.7,615.5,418,569.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M406.8,401.4c-3.4,1.7-6.6,3.1-9.7,4.4c-30.2,12.6-44.3,7.3-50.2,2.7c-2.8-2.1-3.7-4.1-3.7-4.1l0,0l0,0 c0,0,0,0,0,0.1c0.2,1.9,6.1,43.6,73.2,43.6c68.7,0,81.8-24,81.8-40.8C498.2,336.6,459.3,375.7,406.8,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M653.2,404.3L653.2,404.3c0,0-1,2-3.7,4.1c-5.9,4.6-20,9.9-50.2-2.7c-3.1-1.3-6.3-2.7-9.7-4.4 c-52.5-25.6-91.4-64.8-91.4,5.8c0,16.8,13.1,40.8,81.8,40.8C647.1,448,652.9,406.3,653.2,404.3L653.2,404.3L653.2,404.3z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M496.9,396.6c16.2,0,30.4-8.5,38.4-21.4c4.3-6.9,6.8-15,6.8-23.7c0-11.6-19.5-17.8-40.4-18.6 c-1.6-0.1-3.2-0.1-4.7-0.1c-1.6,0-3.2,0-4.7,0.1c-20.9,0.8-40.4,7-40.4,18.6c0,8.7,2.5,16.8,6.7,23.7 C466.4,388,480.6,396.6,496.9,396.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M343.7,492c4.9,47.6,54.9,102.9,18,142.2c-26.8,28.5-76.1-3.4-80.5-11.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M248.4,450.4c-0.7,3.5-1.4,7.1-2.1,10.6c-3.6,20.3-5.5,41.3-5.5,62.9c0,42.2,7.2,82.3,20.3,118.7 c1.2,2.8,2.5,6,4.3,9.6c2.1,4.1,21.9,46.2,22.7,47.6c21.2,35.3,48.7,64.8,80.5,86.3c6.9,4.7,14.8,6.9,22.6,6.9 c10.4,0,20.7-4,28.4-11.5v-257C361.9,499.4,284.8,466.1,248.4,450.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M248.4,450.4c-0.7,3.5-1.4,7.1-2.1,10.6c-3.6,20.3-5.5,41.3-5.5,62.9c0,42.2,7.2,82.3,20.3,118.7 c1.2,2.8,2.5,6,4.3,9.6c2.1,4.1,21.9,46.2,22.7,47.6c21.2,35.3,48.7,64.8,80.5,86.3c6.9,4.7,14.8,6.9,22.6,6.9 c10.4,0,20.7-4,28.4-11.5v-257C361.9,499.4,284.8,466.1,248.4,450.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 446.3,
    className: "st12",
    width: 22.8,
    height: 361.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 761.4,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.6,
    y: 691.9,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.6,
    y: 622.3,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.6,
    y: 552.8,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 483.3,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.6,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M248.4,450.4c-0.7,3.5-1.4,7.1-2.1,10.6c-3.6,20.3-5.5,41.3-5.5,62.9c0,42.2,7.2,82.3,20.3,118.7 c1.2,2.8,2.5,6,4.3,9.6c2.1,4.1,21.9,46.2,22.7,47.6c21.2,35.3,48.7,64.8,80.5,86.3c6.9,4.7,14.8,6.9,22.6,6.9 c10.4,0,20.7-4,28.4-11.5v-257C361.9,499.4,284.8,466.1,248.4,450.4z"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M341.7,504.6c4.9,47.5,54.9,102.9,18,142.2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M372.1,594.3c4.4,19,3.4,37.1-11.2,52.6c-26.8,28.5-76.1-3.4-80.5-11.9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 269.5,
    y: 591.1,
    transform: "matrix(0.9153 -0.4028 0.4028 0.9153 -215.4915 180.2136)",
    className: "st10",
    width: 102.5,
    height: 22.6
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "419.4,589.5 260.3,483.3 272,462.3 443.5,532.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    points: "419.4,589.5 260.3,483.3 272,462.3 443.5,532.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.2,
    y: 412.9,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -392.5234 471.303)",
    className: "st12",
    width: 26.4,
    height: 411.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.9,
    y: 334.1,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -317.4158 475.4933)",
    className: "st12",
    width: 26.4,
    height: 426.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "197.6,445.6 204.2,429.5 562.7,630.8 556.2,646.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 213.1,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -170.4639 504.8275)",
    className: "st12",
    width: 26.4,
    height: 411.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.9,
    y: 146.5,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -96.444 516.0023)",
    className: "st12",
    width: 26.4,
    height: 411.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.9,
    y: 567.8,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -266.7523 641.6736)",
    className: "st13",
    width: 411.2,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.3,
    y: 519.9,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -255.5931 567.6447)",
    className: "st13",
    width: 411.2,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.6,
    y: 472,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -244.434 493.6157)",
    className: "st13",
    width: 411.2,
    height: 26.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "183.3,612 161.2,598.7 401.2,264.8 423.4,278.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 376.2,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -222.1158 345.5579)",
    className: "st13",
    width: 411.2,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 509.5,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -370.1737 323.2633)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.9,
    y: 442.9,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -296.1538 334.4381)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    y: 376.3,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -222.134 345.6129)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.7,
    y: 309.6,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -148.1006 356.6975)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.6,
    y: 243,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -74.0807 367.8724)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.6,
    y: 557.4,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -381.3485 397.2831)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.5,
    y: 490.8,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -307.3286 408.4579)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.4,
    y: 424.2,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -233.3088 419.6328)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.3,
    y: 357.5,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -159.2754 430.7174)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.2,
    y: 290.9,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -85.2556 441.8922)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.2,
    y: 605.3,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -392.5234 471.303)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.1,
    y: 538.7,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -318.5036 482.4778)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.9,
    y: 405.4,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -170.4502 504.7373)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.8,
    y: 338.8,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -96.4304 515.9121)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.8,
    y: 653.2,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -403.6983 545.3228)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.8,
    y: 586.6,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -329.6784 556.4976)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.5,
    y: 453.3,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -181.625 578.7571)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.4,
    y: 386.7,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -107.6053 589.9321)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.5,
    y: 701.1,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -414.8731 619.3427)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.4,
    y: 634.5,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -340.8533 630.5175)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.2,
    y: 567.8,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -266.8198 641.6022)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.1,
    y: 501.2,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -192.7999 652.777)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 434.6,
    transform: "matrix(0.5838 -0.8119 0.8119 0.5838 -118.7801 663.9518)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }))))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "419.4,589.5 260.3,483.3 272,462.3 443.5,532.7  "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "320.7,515.1 343.8,528.1 353.9,514.1 330.7,501 320.3,515.6  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "403,541.7 392.3,555.7 415.7,568.4 426.1,554.6  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "281.8,473.7 270.7,468.7 263.4,481.7 271.8,487.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M712.5,622.3c-4.4,8.5-53.7,40.4-80.5,11.9c-36.9-39.3,13.1-94.6,18-142.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M574.1,524.5v257c7.7,7.5,18,11.5,28.4,11.5c7.8,0,15.7-2.2,22.6-6.9c31.8-21.5,59.3-51,80.5-86.3 c0.8-1.4,20.6-43.5,22.7-47.6c1.8-3.6,3.1-6.8,4.3-9.6c13.1-36.4,20.3-76.5,20.3-118.7c0-21.6-1.9-42.6-5.5-62.9 c-0.7-3.5-1.4-7.1-2.1-10.6C708.9,466.1,631.8,499.4,574.1,524.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M574.1,524.5v257c7.7,7.5,18,11.5,28.4,11.5c7.8,0,15.7-2.2,22.6-6.9c31.8-21.5,59.3-51,80.5-86.3 c0.8-1.4,20.6-43.5,22.7-47.6c1.8-3.6,3.1-6.8,4.3-9.6c13.1-36.4,20.3-76.5,20.3-118.7c0-21.6-1.9-42.6-5.5-62.9 c-0.7-3.5-1.4-7.1-2.1-10.6C708.9,466.1,631.8,499.4,574.1,524.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 805.9,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 446.3,
    className: "st12",
    width: 22.8,
    height: 361.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.1,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.3,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.4,
    y: 459.4,
    className: "st12",
    width: 22.8,
    height: 348.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 761.4,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.9,
    y: 691.9,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.9,
    y: 622.3,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.9,
    y: 552.8,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 483.3,
    className: "st13",
    width: 355.2,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.9,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.1,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.3,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.4,
    y: 483.3,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.9,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.1,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.3,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.4,
    y: 552.8,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.9,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.1,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.3,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.4,
    y: 622.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.9,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.1,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.3,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.4,
    y: 691.9,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.9,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.1,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.3,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.4,
    y: 761.4,
    className: "st14",
    width: 22.8,
    height: 22.4
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M574.1,524.5v257c7.7,7.5,18,11.5,28.4,11.5c7.8,0,15.7-2.2,22.6-6.9c31.8-21.5,59.3-51,80.5-86.3 c0.8-1.4,20.6-43.5,22.7-47.6c1.8-3.6,3.1-6.8,4.3-9.6c13.1-36.4,20.3-76.5,20.3-118.7c0-21.6-1.9-42.6-5.5-62.9 c-0.7-3.5-1.4-7.1-2.1-10.6C708.9,466.1,631.8,499.4,574.1,524.5z"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M634,646.8c-36.9-39.3,13.1-94.7,18-142.2"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M713.3,635c-4.4,8.5-53.7,40.4-80.5,11.9c-14.6-15.5-15.6-33.6-11.2-52.6"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 661.7,
    y: 551.2,
    transform: "matrix(0.4028 -0.9153 0.9153 0.4028 -149.4928 975.7579)",
    className: "st10",
    width: 22.6,
    height: 102.5
  })), /*#__PURE__*/React.createElement("g", null, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "550.2,532.7 721.7,462.3 733.4,483.3 574.3,589.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "550.2,532.7 721.7,462.3 733.4,483.3 574.3,589.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.7,
    y: 605.3,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -223.7186 542.6716)",
    className: "st12",
    width: 411.2,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 534.1,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -190.0067 504.976)",
    className: "st12",
    width: 426.5,
    height: 26.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "437.5,646.8 431,630.8 789.5,429.5 796.1,445.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.9,
    y: 405.5,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -134.0951 421.1752)",
    className: "st12",
    width: 411.2,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 338.9,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -104.2206 380.6764)",
    className: "st12",
    width: 411.2,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 375.4,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -244.9197 401.8954)",
    className: "st13",
    width: 26.4,
    height: 411.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.6,
    y: 327.5,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -204.424 431.7817)",
    className: "st13",
    width: 26.4,
    height: 411.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.3,
    y: 279.6,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -163.9284 461.668)",
    className: "st13",
    width: 26.4,
    height: 411.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "570.3,278.1 592.5,264.8 832.5,598.7 810.4,612  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.5,
    y: 183.8,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -82.9371 521.4406)",
    className: "st13",
    width: 26.4,
    height: 411.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.3,
    y: 509.5,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -142.7209 602.4206)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.4,
    y: 442.9,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -112.8464 561.9218)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.5,
    y: 376.3,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -82.9719 521.423)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.6,
    y: 309.6,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -53.0481 480.9606)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.7,
    y: 243,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -23.1737 440.4618)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.7,
    y: 557.4,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -183.2197 572.5461)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.8,
    y: 490.8,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -153.3452 532.0473)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.9,
    y: 424.2,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -123.4707 491.5485)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 357.5,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -93.5469 451.0861)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.1,
    y: 290.9,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -63.6724 410.5873)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.1,
    y: 605.3,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -223.7186 542.6716)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.2,
    y: 538.7,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -193.8441 502.1728)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.4,
    y: 405.4,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -134.0457 421.2116)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.5,
    y: 338.8,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -104.1712 380.7128)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.5,
    y: 653.2,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -264.2173 512.7972)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.5,
    y: 586.6,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -234.3428 472.2984)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.8,
    y: 453.3,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -174.5445 391.3372)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.9,
    y: 386.7,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -144.6701 350.8383)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.8,
    y: 701.1,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -304.7161 482.9227)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.9,
    y: 634.5,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -274.8417 442.4239)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.1,
    y: 567.8,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -244.9178 401.9615)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.2,
    y: 501.2,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -215.0433 361.4626)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.3,
    y: 434.6,
    transform: "matrix(0.8119 -0.5838 0.5838 0.8119 -185.1689 320.9639)",
    className: "st14",
    width: 26.4,
    height: 26.4
  }))))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "550.2,532.7 721.7,462.3 733.4,483.3 574.3,589.5  "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "673,515.1 649.9,528.1 639.8,514.1 663,501 673.4,515.6  "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "590.7,541.7 601.4,555.7 578,568.4 567.6,554.6  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "711.9,473.7 723,468.7 730.3,481.7 721.9,487.7  "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaver1);
export default __webpack_public_path__ + "static/media/beaver1.2bea477a8c59e8b4c48a0a93f59c44af.svg";
export { ForwardRef as ReactComponent };